/** @velyn-custom BEGIN — vely-ajax-newsletter-form.js
 *  Does NOT intercept form submit (native POST required for Shopify).
 *
 *  1. return_to=/ so success lands on home with ?customer_posted=true
 *  2. After success: toast + scroll/highlight footer newsletter
 *
 *  NOTE: Shopify.captcha.protect() wiring (step "early-wire captcha") was
 *  removed on request — this is why the hCaptcha badge no longer appears.
 *  The /challenge-page enhancement below (enhanceChallengePage) is now
 *  dead code in practice since the form won't redirect there anymore, but
 *  is left in place untouched.
 *
 *  Wrapped in an IIFE + a window-level guard: this file is intentionally
 *  included by both vely-newsletter-popup.liquid and vely-footer.liquid
 *  (both sitewide sections), so on any page where both render it loads
 *  twice. As a classic (non-module) script its top-level `const`/`let`
 *  share one script-global scope, so a second load without this guard
 *  throws "Identifier has already been declared" and aborts.
 */
(function () {
  if (window.__velyAjaxNewsletterFormLoaded) return;
  window.__velyAjaxNewsletterFormLoaded = true;

  const FORM_SELECTOR = ".vely-footer__newsletter-form, .vely-newsletter-popup__form";
  const SUCCESS_FLAG = "vely_nl_success";

function isChallengePage() {
  return window.location.pathname === "/challenge";
}

function challengeCopy() {
  const lang = (document.documentElement.lang || "").toLowerCase();
  if (lang.startsWith("de")) {
    return {
      title: "Nur noch ein Schritt",
      tip: "Bestätige „Ich bin ein Mensch“ und tippe danach auf Senden, um dich für den Newsletter anzumelden.",
    };
  }
  return {
    title: "One more step",
    tip: "Confirm “I am human”, then tap Send to finish your newsletter signup.",
  };
}

function enhanceChallengePage() {
  document.body.classList.add("vely-template-challenge");

  const main = document.getElementById("MainContent");
  if (!main || main.dataset.velyChallengeEnhanced === "true") return;
  main.dataset.velyChallengeEnhanced = "true";

  const card = document.createElement("div");
  card.className = "vely-challenge-card";

  const copy = challengeCopy();
  const title = document.createElement("h1");
  title.className = "vely-challenge-card__title";
  title.textContent = copy.title;

  const tip = document.createElement("p");
  tip.className = "vely-challenge-card__tip";
  tip.textContent = copy.tip;

  card.appendChild(title);
  card.appendChild(tip);

  while (main.firstChild) {
    card.appendChild(main.firstChild);
  }
  main.appendChild(card);

  // Bring the card into the viewport and focus the primary action.
  window.requestAnimationFrame(function () {
    card.scrollIntoView({ behavior: "smooth", block: "center" });
    const submit =
      main.querySelector('button[type="submit"], input[type="submit"], button:not([type])') ||
      main.querySelector("button");
    if (submit && typeof submit.focus === "function") {
      try {
        submit.focus({ preventScroll: true });
      } catch (err) {
        submit.focus();
      }
    }
  });
}

function ensureReturnTo(form) {
  let input = form.querySelector('input[name="return_to"]');
  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = "return_to";
    form.appendChild(input);
  }
  input.value = "/";
}

function wireCaptcha(form) {
  if (!(form instanceof HTMLFormElement)) return;
  if (form.dataset.velyCaptchaWired === "true") return;
  form.dataset.velyCaptchaWired = "true";

  // Captcha intentionally disabled on request — removes the hCaptcha badge
  // from the newsletter forms. Previously set data-shopify-captcha="true"
  // and called Shopify.captcha.protect(form) on focus/pointerdown; both
  // removed. Everything else (AJAX submit flow, return_to, success toast,
  // /challenge page styling) is untouched.
  ensureReturnTo(form);
}

function showSuccessNearFooter() {
  const form = document.querySelector(".vely-footer__newsletter-form");
  if (!form) return;

  form.classList.add("vely-footer__newsletter-form--success");
  form.scrollIntoView({ behavior: "smooth", block: "center" });

  let note = form.parentElement?.querySelector(".vely-newsletter-success-note");
  if (!note) {
    note = document.createElement("div");
    note.className = "vely-newsletter-success-note";
    note.setAttribute("role", "status");
    const text =
      window.message?.newsletter?.success ||
      "Danke für Ihre Anmeldung!";
    note.textContent = text;
    form.insertAdjacentElement("beforebegin", note);
  }

  window.setTimeout(function () {
    form.classList.remove("vely-footer__newsletter-form--success");
  }, 8000);
}

function handleNewsletterSuccessLanding() {
  const fromQuery = /[?&]customer_posted=true(?:&|$)/.test(window.location.search);
  const fromFlag = sessionStorage.getItem(SUCCESS_FLAG) === "1";

  if (fromQuery) {
    sessionStorage.setItem(SUCCESS_FLAG, "1");
  }

  if (!fromQuery && !fromFlag) return;

  sessionStorage.removeItem(SUCCESS_FLAG);

  window.setTimeout(function () {
    showSuccessNearFooter();
  }, 100);
}

function init(root) {
  if (isChallengePage()) {
    enhanceChallengePage();
    return;
  }

  handleNewsletterSuccessLanding();
  (root || document).querySelectorAll(FORM_SELECTOR).forEach(wireCaptcha);
}

// Capture success query as early as possible (before other scripts strip it).
if (/[?&]customer_posted=true(?:&|$)/.test(window.location.search)) {
  sessionStorage.setItem(SUCCESS_FLAG, "1");
}

document.addEventListener("vely:newsletter-posted", function () {
  sessionStorage.setItem(SUCCESS_FLAG, "1");
  handleNewsletterSuccessLanding();
});

init();
document.addEventListener("shopify:section:load", function (event) {
  init(event.target);
});
})();
/** @velyn-custom END — vely-ajax-newsletter-form.js */
